import React from "react";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import i18n from "../../../constants/i18n";
import ReportActionAnalyticsForm from "./report-actions-analytics-form";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import ReportActionsAnalyticsData from "./report-actions-analytics-data";

const ReportActionAnalytics = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_REPORT_ACTIONS_ANALYTICS",
      "AUDITOR_REPORT_ACTIONS_ANALYTICS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("REPORT_ACTIONS_ANALYTICS")}
        subTitle={i18n.get("REPORT_ACTIONS_ANALYTICS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ReportActionAnalyticsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ReportActionsAnalyticsData />
    </ET3PageDiv>
  );
});
export default ReportActionAnalytics;
